import { render, staticRenderFns } from "./release_skeleton_loader.vue?vue&type=template&id=c3f85366&"
import script from "./release_skeleton_loader.vue?vue&type=script&lang=js&"
export * from "./release_skeleton_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports